import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

const setGamesHomeWrapper = (variant: DefaultComponentVariantType | null): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            display: flex;
            flex-flow: column nowrap;
            gap: 16px;
        `;
    }
    return css``;
};

interface GamesHomeWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const GamesHomeWrapper = withConfig(theme => styled('div', { label: 'GamesHomeWrapper' })<GamesHomeWrapperPropsType>`
    ${({ variant }): SerializedStyles => setGamesHomeWrapper(variant)}
    padding: 0 0 16px 16px;
    @media ${theme.star.mediaQuery.desktop} {
        padding-left: 24px;
    }
`);

export const GamesWrapper = styled('div', { label: 'GamesWrapper' })`
    align-items: flex-start;
    display: grid;
    gap: 8px;
    grid-auto-flow: column;
    justify-content: flex-start;
`;

export const GridWrapper = withConfig(theme => styled('div', { label: 'GridWrapper' })`
    align-items: flex-start;
    display: grid;
    grid-auto-flow: row;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    justify-content: flex-start;
    margin-right: 16px;
    min-width: 288px;
    overflow-y: hidden;

    @media ${theme.star.mediaQuery.xxMobile} {
        grid-auto-flow: column;
        grid-template-columns: auto auto;
        margin-right: 0;
        overflow-y: initial;
    }
`);
